module.exports = __webpack_public_path__ + "angle-right.3kAoajBx.svg";